/**
 * @readonly
 * @enum {string} an Enum containing all possible variants of event types
 * */
export enum EventType {
  Evaluation = 'evaluation',
  ConfigurationUpdate = 'configurationUpdate',
}

/**
 * @type EvaluationEventDataType - object containing information about the evaluation event data
 * */
export type EvaluationEventDataType = {
  featureKey: string;
  variation: {
    experimentId: number | null;
    id: number | null;
    key: string;
  };
};

/**
 * @type ConfigurationUpdateEventDataType - object containing information about the configuration update event data
 * */
export type ConfigurationUpdateEventDataType = {
  timestamp: number;
};

/**
 * @type EventDataType - mapped type containing the link between `EventType` and the corresponding data type
 * */
export type EventDataType = {
  [EventType.Evaluation]: EvaluationEventDataType;
  [EventType.ConfigurationUpdate]: ConfigurationUpdateEventDataType;
};

/**
 * @type EventCallbackType - a function that takes `EventDataType<EventType>` as an argument and returns `void`
 * */
export type EventCallbackType<E extends EventType> = (
  eventData: EventDataType[E],
) => void;
